import { type FC } from 'react';

import { Box, Flex } from '@myphx-engineering/phx-design-system';
import { useIsMobile } from '@myphx-engineering/phx-design-system/hooks';
import {
    INSURANCE_OFFER_PRIORITY,
    SELF_PAY_OFFER_PRIORITY,
    isInsuranceOfferType,
    isSelfPayOfferType,
} from '@phx/data-sources/medication-marketplace';

import { useFillPrescription } from '../../../../contexts/fill/use-fill-prescription';
import { getBestOffer } from '../../../../hooks/use-prescription-offers';

import { SelectInsurancePathCardV2 } from './SelectInsurancePathCardV2';
import { SelectSelfPayPathCardV2 } from './SelectSelfPayPathCardV2';

export const InsurancePathSelectionCardsV2: FC = () => {
    const { allOffers } = useFillPrescription();
    const isMobile = useIsMobile('sm');

    const selfPayOffers = allOffers.filter((offer) =>
        isSelfPayOfferType(offer.headlinePriceType)
    );
    const insuranceOffers = allOffers.filter((offer) =>
        isInsuranceOfferType(offer.headlinePriceType)
    );

    const bestSelfPayOffer = getBestOffer(
        selfPayOffers,
        SELF_PAY_OFFER_PRIORITY
    );
    const bestInsuranceOffer = getBestOffer(
        insuranceOffers,
        INSURANCE_OFFER_PRIORITY
    );

    return (
        <Flex gap="xs" style={{ flexDirection: isMobile ? 'column' : 'row' }}>
            <Box flex={1}>
                <SelectInsurancePathCardV2 offer={bestInsuranceOffer} />
            </Box>
            <Box flex={1}>
                <SelectSelfPayPathCardV2 offer={bestSelfPayOffer} />
            </Box>
        </Flex>
    );
};
